import React from "react";
import LogoContainer from "../common/LogoContainer";
import { useTranslation } from "react-i18next";

function BreachHeaderText() {
    const { t: tLang, i18n: i18nLang } = useTranslation();

    return (
        <div className="col-xs-12 row" style={{ color: "#00313c" }}>
            <h1 className="title-page" id="breach-header-text-component" tabIndex={-1} style={{ verticalAlign: "sub", display: "inline-block" }}>
                {tLang("dashboard.breachIq.title")}
            </h1>

            <span className="breach-sup-text">TM</span>
            <LogoContainer internalPage={true} />
        </div>
    );
}

export default BreachHeaderText;
